module.exports = __webpack_public_path__ + "img/icons_6.7c7df1e3.png";